/* Close Trade's mobile navigation when jumping to the studio on the current page. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-ws-studio-link], [data-ws-anchor-link]');
  if (!link) return;
  const target = new URL(link.href, location.href);
  if (target.origin !== location.origin || target.pathname !== location.pathname) return;
  const drawer = link.closest('header-drawer');
  if (drawer && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
  drawer?.querySelector('summary')?.setAttribute('aria-expanded', 'false');
});

/* Equalise rows from their actual text, without cutting off long product names. */
(() => {
  const observed = new Map();
  let frame;
  const sync = () => {
    frame = null;
    for (const [grid] of observed) {
      if (!grid.isConnected) { resize?.unobserve(grid); observed.delete(grid); }
    }
    document.querySelectorAll('.product-grid').forEach((grid) => {
      if (!observed.has(grid)) { observed.set(grid, grid.clientWidth); resize?.observe(grid); }
      const cards = [...grid.querySelectorAll('.ws-product-card')];
      if (!cards.length || !grid.clientWidth) return;
      const maximum = (selector) => Math.ceil(Math.max(0, ...cards.map(card => card.querySelector(selector)?.getBoundingClientRect().height || 0)));
      const values = {
        '--ws-title-height': maximum('.card > .card__content .card__heading > a'),
        '--ws-price-height': maximum('.card > .card__content .card-information > .price'),
        '--ws-options-height': maximum('.ws-card-variant'),
        '--ws-error-height': maximum('.product-form__error-message-wrapper')
      };
      if (values['--ws-options-height']) values['--ws-options-height'] += 10;
      if (values['--ws-error-height']) values['--ws-error-height'] += 10;
      for (const [name,value] of Object.entries(values)) {
        if (grid.style.getPropertyValue(name) !== `${value}px`) grid.style.setProperty(name,`${value}px`);
      }
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
  const resize = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(entries => {
    for (const {target} of entries) {
      if (observed.get(target) !== target.clientWidth) { observed.set(target,target.clientWidth); schedule(); }
    }
  });
  const start = () => {
    schedule();
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
    document.fonts?.ready.then(schedule);
    document.fonts?.addEventListener('loadingdone',schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('change',event => {
    if (!event.target.matches('.ws-card-variant')) return;
    const form = event.target.closest('form');
    const option = event.target.selectedOptions[0];
    const quantity = form?.querySelector('[name="quantity"]');
    if (quantity && option) {
      quantity.min = option.dataset.quantityMin || '1';
      quantity.step = option.dataset.quantityStep || '1';
      if (option.dataset.quantityMax) quantity.max = option.dataset.quantityMax;
      else quantity.removeAttribute('max');
      quantity.value = quantity.min;
    }
    const stock = event.target.closest('.ws-product-card')?.querySelector('[data-ws-low-stock]');
    if (stock && option) {
      stock.textContent = option.dataset.stockText || '';
      stock.dataset.stockState = option.dataset.stockState || 'available';
      stock.hidden = !option.dataset.stockText;
    }
  });
})();

/* Quantity controls and horizontal rows work for both initial and newly loaded cards. */
document.addEventListener('click', (event) => {
  const quantityButton = event.target.closest('[data-ws-quantity]');
  if (quantityButton) {
    const input = quantityButton.closest('.ws-card-quantity')?.querySelector('input[name="quantity"]');
    if (!input) return;
    try {
      if (quantityButton.dataset.wsQuantity === 'plus') input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (_) { /* Browser validity prevents invalid quantities from being submitted. */ }
    return;
  }
  const scrollButton = event.target.closest('[data-ws-scroll]');
  if (!scrollButton) return;
  const scroller = scrollButton.closest('[data-ws-row]')?.querySelector('[data-ws-scroll-container]');
  if (scroller) scroller.scrollBy({ left: scroller.clientWidth * (scrollButton.dataset.wsScroll === 'next' ? .8 : -.8), behavior: 'smooth' });
});

/* Read sorted products and further pages from the relevant Shopify collection context. */
(() => {
  async function loadFeed(marker) {
    if (marker.dataset.wsLoading) return;
    marker.dataset.wsLoading = 'true';
    const root = marker.closest('[data-ws-row]');
    const target = root?.querySelector('[data-ws-feed-target]');
    const status = root?.querySelector('[data-ws-feed-status]');
    if (!root || !target) return;
    const first = new URL(marker.dataset.feedUrl, location.href);
    const sectionId = first.searchParams.get('section_id');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    const seen = new Set();
    let next = first.href;
    try {
      while (next && marker.isConnected) {
        const url = new URL(next, location.origin);
        url.searchParams.set('section_id', sectionId);
        if (preview) url.searchParams.set('preview_theme_id', preview);
        if (seen.has(url.href)) throw new Error('Repeated pagination URL');
        seen.add(url.href);
        const response = await fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Could not load products');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const page = html.querySelector('[data-ws-page]');
        if (!page) throw new Error('Missing section data');
        if (marker.dataset.feedMode === 'replace') target.replaceChildren();
        while (page.firstElementChild) target.append(page.firstElementChild);
        if (status) status.textContent = '';
        next = marker.dataset.feedMode === 'replace' ? '' : page.dataset.next;
      }
      if (!target.children.length && status) status.textContent = 'Zurzeit sind hier keine Produkte verfügbar.';
    } catch (_) {
      if (status) status.textContent = 'Weitere Einträge konnten nicht geladen werden. Über den Button unten findest du alle.';
    }
  }
  function init(scope) { scope.querySelectorAll('[data-ws-auto-feed]').forEach(loadFeed); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

/* Never keep old rolling seven-day figures visible after their data expires. */
(() => {
  function expireBuyerFigures() {
    const now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-ws-buyers-valid-until]').forEach(element => {
      const expiry = Number(element.dataset.wsBuyersValidUntil);
      if (!Number.isFinite(expiry) || now >= expiry) element.remove();
    });
  }
  function startBuyerExpiry() {
    expireBuyerFigures();
    new MutationObserver(expireBuyerFigures).observe(document.body, { childList: true, subtree: true });
    window.setInterval(expireBuyerFigures, 60000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startBuyerExpiry, { once: true });
  else startBuyerExpiry();
})();
